<template>
  <div class="ProductDesc">
    <a href="#APPLink" id="toAPP" name="top"></a>
    <div class="WEB_BG">
      <div class="WEB">
        <img src="../../public/img/WEBProduct.png" alt="" />
        <div class="textProd">
          <h3>"掌尚林草"WEB管理系统介绍</h3>
          <p>
            掌尚林草WEB管理系统，是针对工程数据的共享、分发、回传开发的WEB系统管理平台；
            通过此平台，管理员可直接将调查核查任务发放到终端平台（APP）；
            终端平台（APP）可将核查完毕的工程数据（包含矢量数据、现场照片、轨迹数据）一键回传至管理系统；
            同平台内的终端设备可进行数据共享及流转；让数据上网、让流转高效、让传输精准。
          </p>
          <div class="enterManageSystem" @click="enterSystem">进入管理系统 ></div>
        </div>
      </div>
    </div>
    <div class="APP_BG">
      <a name="APPLink" id="APPLink" ref="APPLink"></a>
      <div class="APP">
        <div class="textProd">
          <h3>"掌尚林草"APP介绍</h3>
          <p>
            {{ shortText }}{{ !showMore ? "..." : ""
            }}{{ showMore ? moreText : "" }}
            <span v-show="!showMore" @click="changeText('open')" class="textBtn"
              >了解更多 ></span
            >
            <span v-show="showMore" @click="changeText('close')" class="textBtn"
              >收起</span
            >
          </p>
          <div class="fenge"></div>
          <div class="APPTeDian">
            <ul>
              <li>
                <img src="../../public/img/tick.png" alt="" />
                <span>无需借助任何第三方平台既可实现常规功能</span>
              </li>
              <li>
                <img src="../../public/img/tick.png" alt="" />
                <span>调查统计等常规功能</span>
              </li>
              <li>
                <img src="../../public/img/tick.png" alt="" />
                <span>产品内置行业字典</span>
              </li>
              <li>
                <img src="../../public/img/tick.png" alt="" />
                <span>图层分屏等众多日常实用功能</span>
              </li>
            </ul>
          </div>
        </div>
        <img src="../../public/img/APPProduct.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shortText: `“掌尚林草”是2019年成都森拓沐然科技有限公司推出一款专业的移动GIS产品，整个研发团队在研发的过程中，汲取了众多类似产品的优点，并融入了自身对于行业的理解，
            在保持专业性的同时，极大的照顾了用户的良好体验`,
      moreText: `。产品作为一个独立的系统存在，无需借助任何第三方平台，既可实现一切日常管理、调查统计等常规功能。
            同时，为了满足林业工作者的日常工作。产品内置行业字典、提供图层分屏等众多日常实用功能。是整个行业的移动GIS的不二之选。`,
      showMore: false,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (val, oldVal) {
        setTimeout(function () {

          let hash = new String(window.location.hash);
          
          let index = hash.lastIndexOf("#");
          if (index != -1) {
            var id = hash.substring(index + 1, hash.length + 1);
            var div = document.getElementById(id);
            // 深度观察监听
            if (div) {
              $("#toAPP")[0].click();
            }
          }
        }, 500);
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    changeText(type) {
      if (type == "open") {
        this.showMore = true;
      } else if (type == "close") {
        this.showMore = false;
      }
    },
    enterSystem(){
      window.open("http://cdn.cdstmr.com:7867/");
    }
  },
};
</script>
<style lang="scss" scoped>
div.ProductDesc {
  height: 100%;

  > div {
    width: 100%;
  }
  div.WEB_BG {
    padding-top: 88px;
    height:550px;
    div.WEB {
      width: 1130px;
      position: relative;
      margin: 0 auto 82px;
      div.textProd {
        width: 566px;
        position: absolute;
        right: 0;
        top: 0;
        h3 {
          font-size: 1.75rem;
        }
        p {
          font-size: 1.25rem;
          text-indent: 2em;
          line-height: 2rem;
          text-align: justify;
        }
        div.enterManageSystem {
          width: 192px;
          height: 64px;
          font-size: 1.25rem;
          border-radius: 4px;
          text-align: center;
          background-color: #00be92;
          color: #fff;
          line-height: 64px;
          cursor: pointer;
        }
      }
    }
  }
  div.APP_BG {
    background-color: #f2f2f2;
    height: 634px;
    padding-top: 88px;
    div.APP {
      width: 1130px;
      margin: 0 auto;
      position: relative;

      div.textProd {
        width: 566px;
        position: absolute;
        left: 0;
        top: 0;
        h3 {
          font-size: 1.75rem;
        }
        p {
          font-size: 1.25rem;
          text-indent: 2em;
          line-height: 2rem;
          margin: 22px 0 30px;
          position: relative;
          text-align: justify;
          .textBtn {
            position: absolute;
            right: 0;
            cursor: pointer;
            color: #00be92;
            font-weight: 700;
            bottom: 0;
            font-size: 1rem;
            border-radius: 4px;
          }
        }
        .fenge {
          border-top: 1px solid #d4d4d4;
        }
        div.APPTeDian {
          ul {
            margin-top: 52px;
            li {
              margin-bottom: 22px;
              font-size: 1.25rem;
              line-height: 2rem;
              img {
                margin-right: 7px;
              }
            }
          }
        }
      }
      > img {
        cursor: pointer;
        float: right;
      }
    }
  }
}
</style>
